const INITIAL_STATE = {
    pricesToLogin: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      pricesToLogin: { values: action.payload, error: null, loading: true },
    };
  }
  